import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class InvoiceModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static getItemUrl(...args) {
        return this.listUrl(...args);
    }

    static listUrl({ organizationId, eventId, orderId }) {
        if (!organizationId || !eventId || !orderId) {
            throw new ArgumentError(`[Model][Invoice][getAll] organizationId, eventId and orderId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/orders/${orderId}/invoice`;
    }
}
